import angular, { ICompileService, IDirective, IScope } from "angular";
import { kebabCase } from "lodash";

export const vsModuleName = "modelComponentSelectorModule";
export const vsDirectiveName = "modelComponentSelector";

export interface WithComponent {
  component: string;
}

angular.module(vsModuleName, []).directive(vsDirectiveName, [
  "$compile",
  ($compile: ICompileService): IDirective => ({
    restrict: "E",
    scope: { item: "<", modelSelector: "&?", context: "<?" },
    link: (scope: any, element) => {
      let childScope: IScope | undefined;
      scope.$watch("item", (item: WithComponent | undefined) => {
        element.empty();
        childScope?.$destroy();
        childScope = undefined;
        if (!item) {
          return;
        }

        const componentTag = kebabCase(item.component);
        childScope = <IScope>scope.$new();
        const modelSelector: (args: {
          item: WithComponent;
          context: unknown;
        }) => unknown = scope.modelSelector ?? ((args) => args.item);
        const model: unknown = modelSelector({ item, context: scope.context });
        (childScope as any).model = model;
        element.append(
          $compile(
            `<${componentTag} model="model" context="context"></${componentTag}>`,
          )(childScope),
        );
      });
    },
  }),
]);
